// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"f46ee7ef","126":"a1b86afa","644":"7ad870ed","680":"bf3cfa81","939":"50c34bc0"}[chunkId] + ".chunk.js";
};